import * as types from '../mutation-types'

const state = {
  nextNotification: null,
  notificationLock: false,
  notificationQuee: [],
  loadingButtons: []
}

const mutations = {
  [types.SHOW_NOTIFICATION] (state, action) {
    if (!state.notificationLock) {
      state.notificationLock = true
      state.nextNotification = action
    } else {
      state.notificationQuee.push(action)
    }
  },

  [types.UNLOCK_NOTIFICATION] (state) {
    if (state.notificationQuee.length) {
      state.nextNotification = state.notificationQuee.shift()
    } else {
      state.nextNotification = null
      state.notificationLock = false
    }
  },

  [types.ADD_LOADING_BTN] (state, action) {
    if (!state.loadingButtons.includes(action)) {
      state.loadingButtons.push(action)
    }
  },

  [types.REMOVE_LOADING_BTN] (state, action) {
    let array = state.loadingButtons
    if (array.includes(action)) {
      state.loadingButtons.splice(array.indexOf(action), 1)
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js